module.exports = __webpack_public_path__ + "img/zh7.bf845b01.png";